export default "__VITE_ASSET__d441154f__"